/**
 * Feature flags configuration
 * Centralized place for all feature toggles controlled by environment variables
 */

/**
 * Controls whether payment flow is enabled in the charging session
 * When false: Users proceed directly from session confirmation to charging
 * When true: Users must complete payment before starting charging session
 * 
 * Set via VITE_PAYMENTS_ENABLED environment variable
 * Defaults to false if not set
 */
export const PAYMENTS_ENABLED = import.meta.env.VITE_PAYMENTS_ENABLED === 'true';

/**
 * Rollout control for the "Before you charge" account-choice first screen
 * ("I am registered" / "Continue as guest").
 *
 * OFF unless VITE_ACCOUNT_CHOICE_ENABLED is exactly 'true' at BUILD time
 * (Vite inlines it). Absent, empty or anything else keeps the entry journey
 * production already runs: charger profile -> (connector choice) -> plate
 * screen.
 *
 * Controls ONLY that screen and its routing. Receipts, Get Receipt, vehicle
 * attachment and the connector-reclaim fix do not read this flag.
 */
export const ACCOUNT_CHOICE_ENABLED = import.meta.env.VITE_ACCOUNT_CHOICE_ENABLED === 'true';
